export const FETCH_CHARTER_LISTINGS = 'FETCH_CHARTER_LISTINGS',
    FETCH_CHARTER_LISTINGS_SUCCESS = 'FETCH_CHARTER_LISTINGS_SUCCESS',
    FETCH_CHARTER_LISTINGS_FAIL = 'FETCH_CHARTER_LISTINGS_FAIL',
    CREATE_CHARTER_LISTING = 'CREATE_CHARTER_LISTING',
    CREATE_CHARTER_LISTING_SUCCESS = 'CREATE_CHARTER_LISTING_SUCCESS',
    CREATE_CHARTER_LISTING_FAIL = 'CREATE_CHARTER_LISTING_FAIL',
    DELETE_CHARTER_LISTING = 'DELETE_CHARTER_LISTING',
    DELETE_CHARTER_LISTING_SUCCESS = 'DELETE_CHARTER_LISTING_SUCCESS',
    DELETE_CHARTER_LISTING_FAIL = 'DELETE_CHARTER_LISTING_FAIL';
